import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TooltipModule } from 'primeng/tooltip';
import { CardModule } from 'primeng/card';
import { ButtonModule } from 'primeng/button';
import { RouterModule } from '@angular/router';
import { AuthService } from '@auth0/auth0-angular';
import { UserService } from '@bioconnect-ui/user-service';


@Component({
  standalone: true,
  imports: [
    CommonModule,
    RouterModule,
    CardModule,
    ButtonModule,
    TooltipModule,
  ],
  selector: 'bioconnect-ui-tile-nav',
  templateUrl: './tile-nav.component.html',
  styleUrls: ['./tile-nav.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TileNavComponent implements OnInit {
  userIsCurator = false;
  colNum = 0;

  constructor(
    public auth: AuthService,
    public UserService: UserService,
    private cdr: ChangeDetectorRef,
  ) {}

  ngOnInit() {
    this.UserService.getUserDetails().subscribe(user => {
      this.userIsCurator = user.is_curator;
      this.cdr.markForCheck();
    });
  }
}
